<div class="user-message">
    <p>
        You have been registered, but have not yet been assigned a role.  Please see your <br>
        supervisor to have a role assigned.
    </p>
</div>

